var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex v-application",
      staticStyle: { bottom: "20px", position: "fixed", "z-index": "3" }
    },
    [
      _c(
        "v-card",
        { staticClass: "elevation-3 d-flex", attrs: { color: _vm.color } },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }